var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProceduresBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5938 11.7303C20.6287 10.6158 19.5426 9.61221 18.3555 8.73811C18.2504 8.66449 18.1252 8.625 17.9969 8.625C17.8686 8.625 17.7434 8.66449 17.6383 8.73811C16.4533 9.61257 15.3693 10.6161 14.4062 11.7303C12.2586 14.1967 11.125 16.7967 11.125 19.2498C11.125 21.0732 11.8493 22.8219 13.1386 24.1112C14.428 25.4005 16.1766 26.1248 18 26.1248C19.8234 26.1248 21.572 25.4005 22.8614 24.1112C24.1507 22.8219 24.875 21.0732 24.875 19.2498C24.875 16.7967 23.7414 14.1967 21.5938 11.7303ZM18 24.8748C16.5087 24.8732 15.0789 24.28 14.0244 23.2255C12.9698 22.1709 12.3767 20.7412 12.375 19.2498C12.375 14.7787 16.7086 11.0467 18 10.0311C19.2914 11.0467 23.625 14.7772 23.625 19.2498C23.6233 20.7412 23.0302 22.1709 21.9756 23.2255C20.9211 24.28 19.4913 24.8732 18 24.8748ZM22.3664 19.9795C22.2043 20.8848 21.7688 21.7186 21.1185 22.3688C20.4681 23.019 19.6342 23.4544 18.7289 23.6162C18.6945 23.6217 18.6598 23.6246 18.625 23.6248C18.4682 23.6248 18.3172 23.5658 18.2018 23.4596C18.0865 23.3535 18.0153 23.2078 18.0023 23.0516C17.9893 22.8953 18.0355 22.7399 18.1318 22.6162C18.228 22.4924 18.3673 22.4093 18.5219 22.3834C19.8164 22.1655 20.9148 21.067 21.1344 19.7701C21.1621 19.6067 21.2537 19.4609 21.3889 19.3649C21.5242 19.269 21.692 19.2307 21.8555 19.2584C22.019 19.2862 22.1647 19.3778 22.2607 19.513C22.3566 19.6482 22.395 19.816 22.3672 19.9795H22.3664Z",
    fill: "#B821FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProceduresBg);
export default __webpack_public_path__ + "static/media/procedures-bg.703b916ad84867de01df3e67e3ec5d90.svg";
export { ForwardRef as ReactComponent };